<!-- Summary Boxes -->
<div class="row g-4 mb-6">
  <!-- Total A/C Receivable Box -->
  <div class="col-md-6">
    <div class="card bg-light-success border-0 h-100">
      <div class="card-body d-flex align-items-center p-6">
        <div class="symbol symbol-50px me-4">
          <div class="symbol-label bg-success">
            <i class="ki-duotone ki-arrow-up fs-2 text-white">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
        </div>
        <div class="flex-grow-1">
          <div class="text-gray-800 fw-bold fs-6 mb-1">Total A/C Receivable</div>
          <div class="fw-bolder fs-2 text-success">{{selectedCurrency == 'usd' ? '$' : '¥'}}{{ totalReceivable |
            number:'1.2-2' }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Total A/C Payable Box -->
  <div class="col-md-6">
    <div class="card bg-light-danger border-0 h-100">
      <div class="card-body d-flex align-items-center p-6">
        <div class="symbol symbol-50px me-4">
          <div class="symbol-label bg-danger">
            <i class="ki-duotone ki-arrow-down fs-2 text-white">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
        </div>
        <div class="flex-grow-1">
          <div class="text-gray-800 fw-bold fs-6 mb-1">Total A/C Payable</div>
          <div class="fw-bolder fs-2 text-danger">{{ totalPayable | currencyFormat:selectedCurrency }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card card-flush">
  <div class="card-body bg-gray-200 px-4 py-2">
    <!-- Currency Filter Radio Buttons -->
    <div class="mb-4">
      <div class="d-flex align-items-center">
        <span class="fw-bold me-4">Currency:</span>
        <div class="form-check form-check-custom form-check-solid me-4">
          <input class="form-check-input" type="radio" name="currency_filter" id="currency_usd" value="usd"
            [checked]="selectedCurrency === 'usd'" (change)="onCurrencyChange('usd')">
          <label class="form-check-label" for="currency_usd">
            USD
          </label>
        </div>
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" name="currency_filter" id="currency_jpy" value="jpy"
            [checked]="selectedCurrency === 'jpy'" (change)="onCurrencyChange('jpy')">
          <label class="form-check-label" for="currency_jpy">
            JPY
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="card-header border-0 pt-0">
    <div class="card-title">
      <div class="d-flex align-items-center position-relative my-1">
        <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <input type="text" class="form-control form-control-sm w-250px ps-12" placeholder="Search"
          (input)="onSearch($event)" [value]="searchTerm" />
      </div>
    </div>
    <div class="card-toolbar flex-row-fluid justify-content-end gap-3">
      <div class="d-inline-flex justify-content-end align-items-center gap-4" data-table-toolbar="base">
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex" [class.active]="showFilters"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Search</span>
          <span class="badge badge-danger ms-2" *ngIf="hasActiveFilters()">{{ getActiveFiltersCount() }}</span>
        </button>
        <button type="button" class="btn btn-sm btn-primary d-flex" (click)="exportExcel()"
          [disabled]="isExportingExcel">
          <span *ngIf="isExportingExcel" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isExportingExcel" class="ki-duotone ki-exit-up fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isExportingExcel ? 'Exporting...' : 'Export' }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFilters" [@slideInOut]>
    <div class="row g-4">
      <!-- Sales Person Search -->
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sales Person</label>
        <div class="position-relative">
          <input type="text" class="form-control form-control-sm" placeholder="Search Sales Person..."
            [(ngModel)]="salesPersonSearchTerm" (input)="onSalesPersonSearchInput($event)"
            (focus)="onSalesPersonInputFocus()" (blur)="onSalesPersonInputBlur()" autocomplete="off" />

          <!-- Clear Button -->
          <button type="button"
            class="btn btn-sm btn-icon btn-light position-absolute top-50 end-0 translate-middle-y me-1"
            *ngIf="selectedSalesPerson || salesPersonSearchTerm" (click)="clearSalesPersonSearch()">
            <i class="ki-duotone ki-cross fs-7">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </button>

          <!-- Sales Person Search Results Dropdown -->
          <div class="dropdown-menu show w-100 mh-300px overflow-auto"
            *ngIf="showSalesPersonDropdown && (salesPersonSearchResults.length > 0 || isSalesPersonSearching)">

            <!-- Loading State -->
            <div class="dropdown-item text-center py-3" *ngIf="isSalesPersonSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching sales persons...
            </div>

            <!-- Search Results -->
            <a class="dropdown-item cursor-pointer py-2" *ngFor="let salesPerson of salesPersonSearchResults"
              (click)="selectSalesPerson(salesPerson)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ getSalesPersonDisplayName(salesPerson) }}</span>
                <small class="text-muted">{{ salesPerson.email }}</small>
              </div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
              *ngIf="!isSalesPersonSearching && salesPersonSearchResults.length === 0">
              No sales persons found
            </div>
          </div>
        </div>
      </div>

      <!-- Customer Search -->
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Customer</label>
        <div class="position-relative">
          <input type="text" class="form-control form-control-sm" placeholder="Search Customer..."
            [(ngModel)]="customerSearchTerm" (input)="onCustomerSearchInput($event)" (focus)="onCustomerInputFocus()"
            (blur)="onCustomerInputBlur()" autocomplete="off" />

          <!-- Clear Button -->
          <button type="button"
            class="btn btn-sm btn-icon btn-light position-absolute top-50 end-0 translate-middle-y me-1"
            *ngIf="selectedCustomer || customerSearchTerm" (click)="clearCustomerSearch()">
            <i class="ki-duotone ki-cross fs-7">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </button>

          <!-- Customer Search Results Dropdown -->
          <div class="dropdown-menu show w-100 mh-300px overflow-auto"
            *ngIf="showCustomerDropdown && (customerSearchResults.length > 0 || isCustomerSearching)">

            <!-- Loading State -->
            <div class="dropdown-item text-center py-3" *ngIf="isCustomerSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching customers...
            </div>

            <!-- Search Results -->
            <a class="dropdown-item cursor-pointer py-2" *ngFor="let customer of customerSearchResults"
              (click)="selectCustomer(customer)">
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ getCustomerDisplayName(customer) }}</span>
                <small class="text-muted">{{ customer.email }}</small>
              </div>
            </a>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
              *ngIf="!isCustomerSearching && customerSearchResults.length === 0">
              No customers found
            </div>
          </div>
        </div>
      </div>

      <!-- Date -->
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Date</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.report_date">
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="d-flex justify-content-end mt-4">
      <button type="button" class="btn btn-sm btn-light me-3" (click)="clearFilters()" [disabled]="!hasActiveFilters()">
        <i class="ki-duotone ki-cross fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Clear All
      </button>
      <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
        <i class="ki-duotone ki-magnifier fs-2">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Apply
      </button>
    </div>
  </div>

  <div class="card-body pt-0">
    <table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden" id="kt_table_client_manager_list">
      <thead>
        <tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
          <th class="text-nowrap">Clients</th>
          <th class="text-nowrap">Sales Person</th>
          <th class="text-nowrap">A/C Receivable</th>
          <th class="text-nowrap">A/C Payable</th>
        </tr>
      </thead>
      <tbody class="text-gray-600 fw-semibold">
        <!-- Loading Row -->
        <tr *ngIf="isLoading">
          <td colspan="7" class="text-center py-10">
            <div class="d-flex align-items-center justify-content-center">
              <div class="spinner-border spinner-border-sm text-primary me-2" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              Loading clients...
            </div>
          </td>
        </tr>

        <!-- No Data Row -->
        <tr *ngIf="!isLoading && clients.length === 0">
          <td colspan="7" class="text-center py-10">
            <div class="text-muted">No clients found</div>
          </td>
        </tr>

        <!-- Client Rows -->
        <tr *ngFor="let client of clients; trackBy: trackByClientId">
          <td class="text-nowrap">
            <a (click)="viewDetailClient(client)" style="cursor: pointer;">
              {{ client.prefix }} {{ client.name }} [{{ client.company }}] {{ client.country }}
            </a>
          </td>
          <td class="text-nowrap">
            {{ client.sales_person }}
          </td>
          <td class="text-nowrap">
            {{client.account_receivable | currencyFormat:selectedCurrency}}
          </td>
          <td class="text-nowrap">
            {{client.account_payable | currencyFormat:selectedCurrency}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination Component -->
  <app-pagination [paginationInfo]="paginationInfo" [loading]="isLoading" (pageChange)="onPageChange($event)">
  </app-pagination>
</div>
